import { composeBundles } from 'redux-bundler'

export interface State {}

export default composeBundles()
